export enum ExchangesEnum {
  Coinspot = 'Coinspot',
  Binance = 'Binance',
  // BTCMarkets = 'BTCMarkets',
  // CoinBase = 'CoinBase',
}
